import { useState } from 'react'
import { Text, TabMenu, Tab } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import QuestDetailInfo from 'views/VvsGotchi/components/QuestDetailInfo'
import QuestDetailGuide from 'views/VvsGotchi/components/QuestDetailGuide'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'
import { Owner, QuestWithConfig } from 'state/vvsgotchi/models'

import { QuestDetailContent, TabItem, TabContent } from './styles'

enum DetailTab {
  Info,
  Guide,
}
const QuestDetailTabs: React.FC<{ owner: Owner; quest: QuestWithConfig }> = ({ owner, quest }) => {
  const { t } = useTranslation()
  const [tabIndex, setTabIndex] = useState<DetailTab>(DetailTab.Info)

  return (
    <QuestDetailContent>
      <TabMenu variant="altered" isEvenly activeIndex={tabIndex} onItemClick={(idx) => setTabIndex(idx)}>
        <Tab>
          <TabItem>
            <PixelatedImage src="/images/vvsGotchi/info.png" grayout={tabIndex !== DetailTab.Info} width="20px" />
            <Text fontSize="14px" color="inherit">
              {t('Information')}
            </Text>
          </TabItem>
        </Tab>
        <Tab>
          <TabItem>
            <PixelatedImage
              src="/images/vvsGotchi/book_brown.png"
              grayout={tabIndex !== DetailTab.Guide}
              width="15px"
            />
            <Text fontSize="14px" color="inherit">
              {t('Step-by-step guide')}
            </Text>
          </TabItem>
        </Tab>
      </TabMenu>

      <TabContent>
        {quest && tabIndex === DetailTab.Info && <QuestDetailInfo quest={quest} owner={owner} />}
        {tabIndex === DetailTab.Guide && <QuestDetailGuide quest={quest} />}
      </TabContent>
    </QuestDetailContent>
  )
}

export default QuestDetailTabs
